import { style } from "@vanilla-extract/css";
import { buttonStyles } from "plos/src/components/buttons/Button/Button.recipe";
import { vars } from "plos/src/styles/theme.css";

export const sheetContainer = style({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  padding: vars.space.m,
  paddingTop: 0,
  height: "100%",
  textAlign: "center",
  color: vars.colors.onSurface,
});

export const header = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: vars.space.l,
});

export const chipNameStyles = style({
  fontSize: vars.fontSizes.heading.xl,
});

export const content = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
});

export const chipDescriptionStyles = style({
  color: vars.colors.onSurface,
  fontSize: vars.fontSizes.body.m,
});

export const buttonWrap = style({
  display: "flex",
  gap: vars.space.s,
});

export const activeTransferButton = style([
  buttonStyles({ appearance: "filled" }),
  {
    opacity: 0.5,
    borderColor: vars.colors.disabled,
    backgroundColor: vars.colors.disabled,
    pointerEvents: "none",
    color: vars.colors.onDisabled,
  },
]);
